export const baseDomain = window.location.origin;
const baseUrl = `${baseDomain}/umbraco/api`;

export enum HttpMethods {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export async function get<Req, Res>(url: string, params?: Req): Promise<Res> {
  const queryString = params ? `?${buildQueryString(params)}` : '';
  const response = await fetch(`${baseUrl}${url}${queryString}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  ensureStatus(HttpMethods.GET, response);
  return response.json() as Promise<Res>;
}

export async function post<Req, Res>(url: string, data?: Req): Promise<Res | undefined> {
  const response = await fetch(`${baseUrl}${url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',      
    },
    body: data ? JSON.stringify(data) : undefined,
  });

  ensureStatus(HttpMethods.POST, response);
  const contentLength = response.headers.get('content-length');
  const contentType = response.headers.get('content-type');

  if (contentLength !== '0' && contentType?.includes('application/json')) {
    return response.json() as Promise<Res>;
  }

  return;
}

/* export async function getBlob(url: string): Promise<Response> {
  const token = await getUmbracoToken();
  const response = await fetch(`${baseUrl}${url}`, {
    method: 'GET',
    headers: {
      'Authorization': `bearer ${token}`,
    },
  });
  ensureStatus(HttpMethods.GET, response);
  return response;
}



export async function put<Req, Res>(url: string, data?: Req): Promise<Res> {
  const token = await getUmbracoToken();
  const response = await fetch(`${baseUrl}${url}`, {
    method: 'PUT',
    headers: {
      'Authorization': `bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: data ? JSON.stringify(data) : undefined,
  });
  ensureStatus(HttpMethods.PUT, response);
  return response.json() as Promise<Res>;
}

export async function patch<Req, Res>(url: string, data?: Req): Promise<Res | undefined> {
  const token = await getUmbracoToken();
  const response = await fetch(`${baseUrl}${url}`, {
    method: 'PATCH',
    headers: {
      'Authorization': `bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: data ? JSON.stringify(data) : undefined,
  });
  
  ensureStatus(HttpMethods.PATCH, response);
  
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return response.json() as Promise<Res>;
  }
  
  return;
}

export async function del<Req, Res>(url: string, data?: Req): Promise<Res | void> {
  const token = await getUmbracoToken();
  const response = await fetch(`${baseUrl}${url}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: data ? JSON.stringify(data) : undefined,
  });
  
  ensureStatus(HttpMethods.DELETE, response);
  const contentType = response.headers.get('content-type');
  const contentLength = response.headers.get('content-length');
  
  if (contentType?.includes('application/json') && contentLength !== '0') {
    return response.json() as Promise<Res>;
  }
  return;
}

export async function upload<Res>(url: string, data: FormData): Promise<Res | void> {
  const token = await getUmbracoToken();
  const response = await fetch(`${baseUrl}${url}`, {
    method: 'POST',
    body: data,
    headers: {
      'Authorization': `bearer ${token}`
    }
  });
  if (!response.ok) {
    throw new Error(`POST request failed: ${response.statusText}`);
  }

  const contentLength = response.headers.get('content-length');
  const contentType = response.headers.get('content-type');
  
  if (contentLength !== '0' && contentType?.includes('application/json')) {
    return response.json() as Promise<Res>;
  }

  return;
} */

function ensureStatus(action: HttpMethods, response: Response): Response {
  if (!response.ok) {
    throw new Error(`${action}: ${response.status} ${response.statusText}`);
  }
  return response;
}

export type QueryValue = string | number | undefined | Array<string | number>;
export type QueryObject = Record<string, QueryValue>;

export function buildQueryString(params: QueryObject): string {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([
    key,
    value 
  ]) => {
    if(value !== undefined) {
      if (Array.isArray(value)) {
        // Handle arrays by adding multiple entries with the same key
        value.forEach(item => searchParams.append(key, item.toString()));
      } else {
        // Handle single string or number values
        searchParams.append(key, value.toString());
      }
    }
  });

  return searchParams.toString();
}
